

import Color from 'color';
export default class DPColors {
	constructor(config) {
		if (config.dpDebugEn) console.log('DPColors');
	}
	// contrast range: 1 - 21
	static getContrastColor(srcColor, preferWhiteText = true, resColorsPossibilities = ['#fff', '#484848'], fallBackContrastThreshold = 3, resColorsFallback = ['#292929']) {
		const contrasts = [];
		resColorsPossibilities.forEach((color) => {
			const colorObj = Color(color);
			contrasts.push({ color: colorObj, contrast: Color(srcColor).contrast(colorObj) });
		});
		if (contrasts.length) {
			if (preferWhiteText) contrasts[0].contrast *= 2.2;
			else contrasts[0].contrast *= 1.5;
			contrasts.sort((a, b) => b.contrast - a.contrast);
			//console.log(contrasts.map((element) => element.contrast));
			if (contrasts[0].contrast < fallBackContrastThreshold) {
				resColorsFallback.forEach((color) => {
					const colorObj = Color(color);
					contrasts.push({ color: colorObj, contrast: Color(srcColor).contrast(colorObj) });
				});
				contrasts.sort((a, b) => b.contrast - a.contrast);
			}
			return contrasts[0].color;
		}
		return resColorsPossibilities[0] ? Color(resColorsPossibilities[0]) : (resColorsFallback[0] ? Color(resColorsFallback[0]) : Color('#fff'));
	}

	static getMostColor(srcColorsObj, rgbIdx /*r = red*, g = green, b = blue*/) {
		let res = null;
		if (srcColorsObj) {
			const colorsObj = [...srcColorsObj];
			colorsObj.sort((a, b) => DPColors.compareColorsByRgbHue(rgbIdx, a, b));
			res = colorsObj[0];
		}
		return res;
	}

	static getRgbHueFeature = (rgbIdx, color) => {
		switch (rgbIdx) {
			case 'r': return color.red() + (color.red() - color.green()) + (color.red() - color.blue());
			case 'g': return color.green() + (color.green() - color.red()) + (color.green() - color.blue());
			case 'b': return color.blue() + (color.blue() - color.red()) + (color.blue() - color.green());
		}
	}

	static getRgbHueAdjustedColor = (rgbIdx, color) => {
		const addVal = 100;
		switch (rgbIdx) {
			case 'r': return Color.rgb(Math.min(color.red() + addVal, 255), Math.max(color.green() - addVal, 0), Math.max(color.blue() - addVal, 0));
			case 'g': return Color.rgb(Math.max(color.red() - addVal, 0), Math.min(color.green() + addVal, 255), Math.max(color.blue() - addVal, 0));
			case 'b': return Color.rgb(Math.max(color.red() - addVal, 0), Math.max(color.green() - addVal, 0), Math.min(color.blue() + addVal, 255));
		}
	}

	static compareColorsByRgbHue = (rgbIdx, a, b) => {
		return DPColors.getRgbHueFeature(rgbIdx, b) - DPColors.getRgbHueFeature(rgbIdx, a);
	}
}